import { createContext, FC, PropsWithChildren, useContext } from 'react';

type TitleContextProps = {
    title?: string;
    onChange: (value?: string) => void;
};

const TitleContext = createContext<TitleContextProps>({
    title: undefined,
    onChange: () => ({}),
});

export const TitleContextProvider: FC<PropsWithChildren<TitleContextProps>> = ({ children, ...props }) => {
    return <TitleContext.Provider value={props}>{children}</TitleContext.Provider>;
};

export const useTitleContext = () => {
    const context = useContext(TitleContext);

    if (!context) {
        throw new Error('No context. Be sure that component contains inside TitleContext component');
    }
    return context;
};
